<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
const activeCategory = ref('recharges');
const { proxy } = getCurrentInstance();

const filteredServices = computed(() => {
  const countryCode = proxy.$stores.user.state.current?.countryCode;
  const list = proxy.$constants.SERVICES.SERVICES_LIST.filter(
    (service) => service.group === activeCategory.value
  );

  return list;
});

const isServiceAvailable = (service) => {
  return isServiceAvailableGlobal(service);
};

const isServiceAvailableGlobal = (service) => {
  const countryCode = proxy.$stores.user.state.current?.countryCode;
  const appData = proxy.$stores.appData.state.data;
  const availability = appData?.serviceAvailability?.[countryCode];
  
  if (!availability) return true;

  if (service.id === '1xbet') return availability.fund1xBet || availability.withdrawal1xBet;
  if (service.id === 'betwinner') return availability.fundBetWinner || availability.withdrawalBetWinner;
  if (service.id === '1win') return availability.fund1Win || availability.withdrawal1Win;
  if (service.id === 'melbet') return availability.fundMelbet || availability.withdrawalMelbet;
  if (service.id === 'eightStarz') return availability.fundEightStarz || availability.withdrawalEightStarz;
  if (service.id === 'usdt') return availability.buyUsdt || availability.sellUsdt;

  return true;
};
</script>

<template>
  <div class="pb-5 h-[65dvh]">
    <div class="relative flex flex-col justify-center">
      <div class="grid grid-cols-3 text-center py-4 relative z-10">
        <div
          v-for="(category, index) in $constants.SERVICES.SERVICES_CATEGORIES"
          :key="category.id"
          @click="activeCategory = category.id"
          class="py-2 cursor-pointer relative z-10 duration-300 -mx-5"
          :class="{
            'text-white font-bold': activeCategory === category.id,
            '': activeCategory !== category.id
          }"
        >
          {{ category.name }}
        </div>
      </div>
      <div
        class="absolute h-1/2 bg-blue-500 transition-all duration-300 ease-[cubic-bezier(0.95,-0.8,0.1,1.45)] w-[33.33%] -skew-x-12 rounded-lg"
        :class="{
          'left-[0%]':
            activeCategory == $constants.SERVICES.SERVICES_CATEGORIES[0]?.id,
          'left-[33.33%]':
            activeCategory == $constants.SERVICES.SERVICES_CATEGORIES[1]?.id,
          'left-[66.66%]':
            activeCategory == $constants.SERVICES.SERVICES_CATEGORIES[2]?.id
        }"
      ></div>
    </div>
    <div class="min-h-full pt-8 relative">
      <div class="w-full h-full absolute opacity-10 top-0 left-0">
        <div class="relative flex justify-center h-12 overflow-hidden">
          <div
            class="w-[3000px] h-[3000px] rounded-full absolute top-0 bg-slate-400"
          ></div>
        </div>
        <div class="w-full h-full bg-slate-400"></div>
      </div>
      <div class="grid grid-cols-3 gap-5 px-8 py-4 relative">
        <component
          :is="service.url ? 'a' : 'div'"
          :href="service.url"
          target="_blank"
          @click="isServiceAvailable(service) && service.event && $bus.emit(service.event, service)"
          class="bg-white p-12 rounded-3xl flex items-center justify-center flex-col relative transition-all duration-500 ease-out"
          v-for="(service, i) in filteredServices"
          :key="service.id"
          :class="{ 
            '-mt-6 mb-6': i % 3 == 1,
            'grayscale opacity-50': !isServiceAvailable(service)
          }"
        >
          <div class="py-[50%] w-full">
            <div
              class="flex flex-col justify-center items-center top-0 left-0 absolute px-2 w-full h-full gap-1 drop-shadow-[0_1rem_1rem_rgb(0_0_0_/_0.1)]"
            >
              <ImgComponent
                class="w-[30%] rounded-lg"
                :src="service.logo"
                alt=""
              />
              <div
                class="whitespace-nowrap text-gray-600 font-bold text-md mt-2"
              >
                {{ service.name }}
              </div>
              <div
                class="whitespace-nowrap text-gray-400 text-sm truncate w-full text-center"
              >
                {{ 
                  isServiceAvailable(service) 
                    ? service.description 
                    : 'Bientôt disponible' 
                }}
              </div>
            </div>
          </div>

        </component>
      </div>
    </div>
  </div>
</template>
